<template>
  <div class="google-auth-return-section">
    <p class="google-auth-return-section__message">
      {{ $t('LoginPage.googleAuthReturn.message') }}
    </p>
    <atom-input-button
      :linkText="$tc('common.backToApp')"
      :isDisabled="false"
      @push="openAppFromBrowser"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import AtomInputButton from '@/components/atoms/input/AtomInputButton.vue'

export default defineComponent({
  name: 'GoogleAuthReturnSection',
  components: {
    AtomInputButton,
  },
  setup() {
    /**
     * 画面のURLに遷移してネイティブアプリへリダイレクトさせる
     */
    const openAppFromBrowser = () => {
      const baseUrl = process.env.VUE_APP_BROWSER_CAN_REDIRECT_TO_APP_BASE_URL || ''
      const { search, hash } = window.location

      // ハッシュルーティングの場合、クエリパラメータをハッシュの中に含める
      // 例: #/login?state=xxx&code=yyy
      let finalUrl = baseUrl

      if (hash) {
        // ハッシュがある場合
        if (hash.includes('?')) {
          // ハッシュ内にクエリパラメータが含まれている場合、そのまま使用
          finalUrl = `${baseUrl}${hash}`
        } else {
          // ハッシュ内にクエリパラメータが含まれていない場合、外部のクエリパラメータを追加
          finalUrl = `${baseUrl}${hash}${search}`
        }
      } else if (search) {
        // ハッシュがない場合、通常のクエリパラメータを使用
        finalUrl = `${baseUrl}${search}`
      }

      window.location.href = finalUrl
    }

    return {
      openAppFromBrowser,
    }
  },
})
</script>

<style scoped lang="scss">
.google-auth-return-section {
  &__message {
    margin: 24px 16px;
    font-size: 14px;
    line-height: 1.8;
    text-align: center;
  }

  &__buttons {
    margin-top: 24px;
  }
}
</style>
